module.exports = __webpack_public_path__ + "img/mini-011.ca34fd6c.jpg";